import Atc from '~/Api/Analytics/Atc';

import ActionTypes from './ActionTypes';

export interface AtcsState {
	request: Promise<any>;
	isFetching: boolean;
	atcs: Atc[] | null;
}

export interface State {
	byFilter: { [key: string]: AtcsState };
	byCode: { [key: string]: Atc };
}

type Action =
	| {
			type: ActionTypes.request;
			request: Promise<any>;
			filter: string;
	  }
	| {
			type: ActionTypes.receive;
			request: Promise<any>;
			filter: string;
			atcs: Atc[] | null;
	  };

function createState(): State {
	return {
		byFilter: {},
		byCode: {},
	};
}

export default function reducer(state: State = createState(), action: Action) {
	switch (action.type) {
		case ActionTypes.request:
			return {
				...state,
				byFilter: {
					...state.byFilter,
					[action.filter]: {
						request: action.request,
						isFetching: true,
						atcs: [],
					},
				},
			};

		case ActionTypes.receive: {
			const atcsState = state.byFilter[action.filter];
			if (atcsState?.request !== action.request) {
				return state;
			}
			if (!action.atcs) {
				const byFilter = { ...state.byFilter };
				delete byFilter[action.filter];
				return { ...state, byFilter };
			}

			return {
				...state,
				byFilter: {
					...state.byFilter,
					[action.filter]: {
						...atcsState,
						isFetching: false,
						atcs: action.atcs,
					},
				},
				byCode: action.atcs.reduce(
					(byCode, atc) => {
						byCode[atc.code] = atc;
						return byCode;
					},
					{ ...state.byCode }
				),
			};
		}

		default:
			return state;
	}
}

export function selectAtcs(state: State, filter: string): AtcsState | null {
	return state.byFilter[filter.slice(0, 1)] || null;
}
